import React from 'react';
import Certifications from '../Certifications/Certifications';
import Achievements from '../Achievements/Achievements';

const Education = () => (
  <section className="section education-section" id="education" aria-labelledby="education-title">
    <div className="shell">
      <div className="section-heading section-heading-row"><div><span className="section-number">07 / EDUCATION & CERTIFICATIONS</span><h2 id="education-title">Foundations & continued learning.</h2></div><p>Formal education, applied training, and credentials that support the work.</p></div>
      <div className="education-layout">
        <div className="education-column"><h3 className="column-heading">Education</h3><article className="education-entry"><span className="mono">2020 — 2023</span><h4>BSc, Computer Science</h4><p>Kannur University · NAM College Kallikandy</p><p className="muted">CGPA 7.82</p><a className="text-link" href="/muhammed-nihas-degree-certificate.jpg" target="_blank" rel="noopener noreferrer">View degree certificate <span aria-hidden="true">↗</span></a></article><article className="education-entry"><span className="mono">2023 — 2025</span><h4>Data Science & AI</h4><p>Brototype, Calicut</p></article></div>
        <div className="education-column"><h3 className="column-heading">Certifications</h3><Certifications /></div>
      </div>
      <Achievements />
    </div>
  </section>
);

export default Education;
